import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackUserEvent, flushUserEvents } from './userEventTracker';
import { normalizeRoute } from './analyticsRouteNormalizer';
import { getActiveMsSince } from './idleTracker';

const MIN_PAGE_VISIT_MS = 2000;

function _emitVisit(page, enteredAt, fullPath) {
  const now = Date.now();
  const wall_ms = now - enteredAt;
  if (wall_ms < MIN_PAGE_VISIT_MS) return;
  const active_ms = getActiveMsSince(enteredAt, now);
  trackUserEvent('page_visit', {
    page,
    duration_ms: active_ms,
    metadata: { full_path: fullPath, wall_ms, idle_ms: Math.max(0, wall_ms - active_ms) },
  });
}

export function usePageTimeTracking() {
  const location = useLocation();
  const currentPage = useRef(normalizeRoute(location.pathname));
  const enteredAt = useRef(Date.now());
  const fullPath = useRef(location.pathname + location.search);

  useEffect(() => {
    const newPage = normalizeRoute(location.pathname);
    if (newPage !== currentPage.current) {
      _emitVisit(currentPage.current, enteredAt.current, fullPath.current);
      currentPage.current = newPage;
      enteredAt.current = Date.now();
      fullPath.current = location.pathname + location.search;
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onBeforeUnload = () => {
      _emitVisit(currentPage.current, enteredAt.current, fullPath.current);
      flushUserEvents({ useBeacon: true });
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);
}
